// 24- ToleranciaTotalVsComposicion $1
export const validacionesPresentacion = (comprobantes: any) => {
    let sumIVAperc = 0;
    let sumIIBBperc = 0;
    let sumatoriaDeImpuestos = 0.0;
    let sumComprobantesTotales = 0.0;
    let sumNeto = 0.0;
    let sumIVA = 0.0;
    let sumTotalSinPercepciones = 0.0;
    if (comprobantes.length > 0) {
      comprobantes.forEach((item: any) => {
        if (item.fat_descripcion_red === "NC" || item.fat_descripcion_red === "NC FAC") {
          sumatoriaDeImpuestos -= item.fac_impuestos;
          sumComprobantesTotales -= item.fac_total;
          sumTotalSinPercepciones -= (item.fac_total - (item.fac_IIBB_percepcion+ item.fac_iva_percepcion));
          sumNeto -= item.fac_neto;
          sumIVA -= item.fac_iva;

          sumIVAperc -= item.fac_iva_percepcion;
          sumIIBBperc -= item.fac_IIBB_percepcion;

        } else {
          sumatoriaDeImpuestos += item.fac_impuestos;
          sumComprobantesTotales += item.fac_total;
          sumTotalSinPercepciones += (item.fac_total - (item.fac_IIBB_percepcion + item.fac_iva_percepcion));
          sumNeto += item.fac_neto;
            sumIVA += item.fac_iva;
            sumIVAperc += item.fac_iva_percepcion;
            sumIIBBperc += item.fac_IIBB_percepcion;
        }
      });
    }
    let sumComparacion = sumNeto + sumatoriaDeImpuestos + sumIVA;
    let diferenciaTotalVsComposicion = Number(sumComparacion - sumTotalSinPercepciones);
    return { diferenciaTotalVsComposicion, sumComprobantesTotales, sumatoriaDeImpuestos, sumTotalSinPercepciones, sumIVAperc, sumIIBBperc };
  }